var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Menu__burger",on:{"click":_vm.handleBurgerClicked}},[_c('MobileMenuOpen',{staticClass:"header__mobile-open"}),_c('MobileMenuClose',{staticClass:"header__mobile-close"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }